import { FC } from 'react';
import IneligibleIcon from '@base/components/src/Icon/IneligibleIcon';
import styles from './CouponApplyErrorMessage.module.css';
import { CouponApplyErrorMessageProps } from './types';

const CouponApplyErrorMessage: FC<CouponApplyErrorMessageProps> = ({ message }) => (
  <div className={styles.couponApplyError}>
    <IneligibleIcon />
    <span className={styles.couponApplyErrorMessage}>{message}</span>
  </div>
);

export default CouponApplyErrorMessage;
